<template>
  <form
    class="new-sales-note"
    @submit.prevent="onSubmit"
  >
    <div class="columns is-multiline">
      <div class="column is-12">
        <VoucherDetails
          ref="voucherDetailsComponent"
          :is-loading="isLoading"
          :inline="true"
        />
      </div>
      <div class="column is-12">
        <Concepts :is-loading="isLoading" />
      </div>

      <div class="column is-12 action-buttons">
        <div class="field is-grouped">
          <p class="control">
            <button
              class="button is-success"
              type="submit"
              :class="{ 'is-loading': isLoading }"
              :disabled="isLoading"
              @click="setSaleNote(true)"
            >
              Crear Nota de Remisión
            </button>
          </p>
          <p class="control">
            <RouterLink
              class="button is-danger"
              :class="{ 'is-loading': isLoading }"
              :disabled="isLoading"
              :to="{ name: 'Home' }"
            >
              Cancelar
            </RouterLink>
          </p>
        </div>
      </div>
    </div>
    <RouterView />
  </form>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';

export default {
  name: 'NewSaleNote',
  components: {
    VoucherDetails: () => import(/* webpackChunkName: "invoice-voucher-details" */ '@/components/Admin/Invoices/NewSaleNote/SaleNoteDetails.vue'),
    Concepts: () => import(/* webpackChunkName: "sale-note-concepts" */ '@/components/Admin/Invoices/NewSaleNote/SaleNoteConcepts.vue'),
  },
  data() {
    return {
      isLoading: false,
      stamp: false,
      isSaleNote: false,
    };
  },
  beforeMount() {
    this.setInitialState();

    this.$store.commit(
      'users/setValues',
      { email: '', name: '' },
    );
  },
  beforeRouteUpdate(to, { name }, next) {
    if (name === 'NewInvoiceCustomerSearcher') {
      this.$refs.voucherDetailsComponent.focusEmail();
    }
    next();
  },
  methods: {
    ...mapMutations({
      setInitialState: 'invoice/setInitialState',
    }),
    ...mapActions({
      saveInvoice: 'invoice/save',
    }),
    setStamp(value) {
      this.stamp = value;
    },
    setSaleNote(value) {
      this.isSaleNote = value;
    },
    async onSubmit() {
      this.isLoading = true;
      const { stamp, isSaleNote } = this;
      try {
        await this.saveInvoice({ stamp, isSaleNote });
        let content;
        let name;
        if (isSaleNote) {
          content = 'Nota de Remisión generada correctamente.';
          name = 'SaleNoteList';
        } else {
          content = stamp ? 'Timbrado exitoso' : 'Guardado correctamente';
          name = stamp ? 'InvoicesHistory' : 'PreInvoiceList';
        }
        this.$store.dispatch('addTemporalNotification', {
          type: 'success',
          content,
        });
        this.isLoading = false;
        this.$router.push({
          name,
        });
      } catch (error) {
        this.$store.dispatch('addTemporalNotification', {
          type: 'danger',
          content: stamp
            ? error.message
            : 'Ocurrio un error al guardar.',
        });
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.new-sales-note {
  padding: 1rem;
}

.action-buttons {
  display: flex;
  justify-content: flex-end;
}

@media screen and (min-width: 1280px) {
  .box {
    flex-direction: column;
  }

  .label.is-centered::before {
    top: inherit;
  }
}
</style>
